import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const galleryItems = [
  { img: 'https://public.readdy.ai/ai/img_res/0ef2c2881873eaff94f67840e2d3ae5a.jpg', title: 'Master Bath Frameless Enclosure', location: 'Summerlin, NV', category: 'Shower Doors', tall: true },
  { img: 'https://readdy.ai/api/search-image?query=modern%20glass%20stair%20railing%20with%20clear%20tempered%20glass%20panels%20and%20stainless%20steel%20posts%20in%20contemporary%20home%20interior%2C%20open%20staircase%20design%2C%20professional%20photo&width=700&height=500&seq=gal002&orientation=landscape', title: 'Open Staircase Glass Railing', location: 'Henderson, NV', category: 'Railings', tall: false },
  { img: 'https://readdy.ai/api/search-image?query=large%20custom%20frameless%20mirror%20wall%20in%20modern%20bathroom%20with%20double%20vanity%2C%20LED%20lighting%2C%20white%20marble%20countertop%2C%20luxury%20interior%20design&width=700&height=500&seq=gal003&orientation=landscape', title: 'Custom Double Vanity Mirror', location: 'Las Vegas, NV', category: 'Mirrors', tall: false },
  { img: 'https://readdy.ai/api/search-image?query=glass%20bathtub%20enclosure%20with%20sliding%20door%20in%20luxury%20bathroom%2C%20clear%20tempered%20glass%2C%20brushed%20gold%20hardware%2C%20freestanding%20tub%2C%20modern%20design&width=600&height=800&seq=gal004&orientation=portrait', title: 'Luxury Tub Enclosure', location: 'Spring Valley, NV', category: 'Tub Enclosures', tall: true },
  { img: 'https://readdy.ai/api/search-image?query=frameless%20glass%20office%20partition%20wall%20in%20modern%20corporate%20office%2C%20frosted%20glass%20panels%2C%20contemporary%20workspace%2C%20natural%20light%2C%20professional%20interior&width=700&height=500&seq=gal005&orientation=landscape', title: 'Corporate Glass Partition', location: 'Las Vegas, NV', category: 'Partitions', tall: false },
  { img: 'https://readdy.ai/api/search-image?query=modern%20glass%20balcony%20railing%20in%20luxury%20Las%20Vegas%20home%20with%20desert%20mountain%20view%2C%20clear%20tempered%20glass%20panels%2C%20stainless%20steel%20hardware%2C%20contemporary%20architecture&width=700&height=500&seq=gal006&orientation=landscape', title: 'Balcony Glass Railing', location: 'Henderson, NV', category: 'Railings', tall: false },
  { img: 'https://readdy.ai/api/search-image?query=custom%20gym%20mirror%20wall%20installation%20in%20modern%20home%20gym%2C%20large%20frameless%20mirrors%2C%20professional%20fitness%20space%2C%20clean%20white%20walls%2C%20bright%20lighting&width=600&height=800&seq=gal007&orientation=portrait', title: 'Home Gym Mirror Wall', location: 'Summerlin, NV', category: 'Mirrors', tall: true },
  { img: 'https://readdy.ai/api/search-image?query=walk-in%20frameless%20glass%20shower%20enclosure%20with%20rain%20shower%20head%2C%20white%20marble%20tiles%2C%20modern%20luxury%20bathroom%2C%20professional%20interior%20photography&width=700&height=500&seq=gal008&orientation=landscape', title: 'Walk-In Glass Shower', location: 'Paradise, NV', category: 'Shower Doors', tall: false },
];

const categories = ['All', 'Shower Doors', 'Railings', 'Mirrors', 'Tub Enclosures', 'Partitions'];
const categoriesEs = ['Todos', 'Puertas de Ducha', 'Barandales', 'Espejos', 'Cerramientos', 'Particiones'];

const GalleryPreview = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const [lightbox, setLightbox] = useState<null | typeof galleryItems[0]>(null);
  const { i18n } = useTranslation();
  const isEs = i18n.resolvedLanguage === 'es';
  const cats = isEs ? categoriesEs : categories;
  const enCats = categories;

  const filtered = activeCategory === 'All' || activeCategory === 'Todos'
    ? galleryItems
    : galleryItems.filter(g => g.category === enCats[cats.indexOf(activeCategory)]);

  return (
    <section className="py-20 md:py-28 bg-[#F8F8F6]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 gap-6">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-3 block">
              {isEs ? 'Nuestro Trabajo' : 'Our Work'}
            </span>
            <h2 className="text-4xl md:text-5xl font-light text-black leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              {isEs ? 'Instalaciones Recientes' : 'Recent Installations'}
            </h2>
          </div>
          <Link to="/gallery" className="inline-flex items-center gap-2 text-sm font-medium text-black border-b border-black pb-0.5 hover:gap-3 transition-all duration-300 whitespace-nowrap cursor-pointer self-start md:self-auto">
            {isEs ? 'Ver Galería Completa' : 'View Full Gallery'} <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Category Filter */}
        <div className="flex items-center gap-2 mb-8 overflow-x-auto scrollbar-hide pb-1">
          {cats.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-300 cursor-pointer ${
                activeCategory === cat ? 'bg-black text-white' : 'bg-white text-gray-600 border border-gray-200 hover:border-black'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Masonry Grid */}
        <div className="columns-1 sm:columns-2 lg:columns-3 xl:columns-4 gap-4 space-y-4">
          {filtered.map((item) => (
            <div
              key={item.title}
              className="break-inside-avoid group cursor-pointer relative overflow-hidden rounded-2xl"
              onClick={() => setLightbox(item)}
            >
              <img
                src={item.img}
                alt={item.title}
                className="w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
                decoding="async"
              />
              {/* Shine sweep */}
              <div className="absolute inset-0 overflow-hidden rounded-2xl pointer-events-none">
                <div className="absolute -inset-full top-0 h-full w-1/2 bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-12 opacity-0 group-hover:opacity-100 group-hover:translate-x-[300%] transition-all duration-800 ease-out" />
              </div>
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400 rounded-2xl" />
              {/* Info */}
              <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-400">
                <span className="text-xs font-semibold text-white/70 uppercase tracking-wider">{item.category}</span>
                <p className="text-white font-semibold text-sm mt-0.5">{item.title}</p>
                <p className="text-white/60 text-xs flex items-center gap-1 mt-0.5">
                  <i className="ri-map-pin-line"></i>{item.location}
                </p>
              </div>
              {/* Expand icon */}
              <div className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-fullscreen-line text-white text-sm"></i>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div
          className="fixed inset-0 z-[200] bg-black/90 flex items-center justify-center p-4 cursor-pointer"
          onClick={() => setLightbox(null)}
        >
          <div className="relative max-w-4xl w-full" onClick={e => e.stopPropagation()}>
            <button
              onClick={() => setLightbox(null)}
              className="absolute -top-12 right-0 text-white/70 hover:text-white text-sm flex items-center gap-2 cursor-pointer"
            >
              <i className="ri-close-line text-xl"></i> Close
            </button>
            <img
              src={lightbox.img}
              alt={lightbox.title}
              className="w-full max-h-[80vh] object-contain rounded-2xl"
              loading="lazy"
              decoding="async"
            />
            <div className="mt-4 text-center">
              <p className="text-white font-semibold">{lightbox.title}</p>
              <p className="text-white/50 text-sm flex items-center justify-center gap-1 mt-1">
                <i className="ri-map-pin-line"></i>{lightbox.location}
              </p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default GalleryPreview;
